export default __webpack_public_path__ + "static/media/sn-help-number.2c1750a6.png";